import React, { useState } from "react";

const AddLocationModal = ({ onClose }) => {
const [locationName, setLocationName] = useState("");

// Determine the API base URL based on the environment
const getApiBaseUrl = () => {
  // Use the REACT_APP_API_URL from .env, fallback to localhost if not set
  return process.env.REACT_APP_API_URL || "http://localhost:8000";
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${getApiBaseUrl()}/api/properties/locations/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: locationName,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to add location");
      }

      alert("Location added successfully!");
      onClose();
    } catch (error) {
      console.error("Error adding location:", error);
      alert("Failed to add location. Please try again.");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Add Location</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-gray-700">Location Name</label>
            <input
              type="text"
              value={locationName}
              onChange={(e) => setLocationName(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-500 text-white px-4 py-2 rounded-md mr-2 hover:bg-gray-600"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
            >
              Add
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddLocationModal;